/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SuccessResponseModel
 */
export interface SuccessResponseModel {
    /**
     * 
     * @type {boolean}
     * @memberof SuccessResponseModel
     */
    success?: boolean;
}

export function SuccessResponseModelFromJSON(json: any): SuccessResponseModel {
    return SuccessResponseModelFromJSONTyped(json, false);
}

export function SuccessResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuccessResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': !exists(json, 'success') ? undefined : json['success'],
    };
}

export function SuccessResponseModelToJSON(value?: SuccessResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
    };
}

